import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import ru from './locales/ru.json';
import uz from './locales/uz.json';

export const LANGUAGES = [
  { code: 'uz', label: "O'zbekcha" },
  { code: 'ru', label: 'Русский' },
  { code: 'en', label: 'English' },
] as const;

function initialLanguage() {
  const stored = typeof localStorage !== 'undefined' ? localStorage.getItem('highcrm.lang') : null;
  if (stored) return stored;
  const browser = typeof navigator !== 'undefined' ? navigator.language.slice(0, 2) : 'uz';
  return ['uz', 'ru', 'en'].includes(browser) ? browser : 'uz';
}

void i18n.use(initReactI18next).init({
  resources: { uz: { translation: uz }, ru: { translation: ru }, en: { translation: en } },
  lng: initialLanguage(),
  fallbackLng: 'uz',
  interpolation: { escapeValue: false },
  returnNull: false,
});

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});

export function setLanguage(lng: string) {
  localStorage.setItem('highcrm.lang', lng);
  void i18n.changeLanguage(lng);
}

export default i18n;
